
export const DistinctFieldList = ({ data, field, filterField = '', filterValue = '' }) => {
  if (data.length > 0 && field) {
    const fieldValues = filterField && filterValue ? data.filter(x => x[filterField] === filterValue).map(x => x[field]) : data.map(x => x[field]);
    return [...new Set(fieldValues)];
  }
};

export const DistinctFieldListWithCounts = ({ data, field }) => {
  if (data.length > 0 && field) {

    const fieldCounts = {};

    data.forEach(posting => {
      const fieldName = posting[field];
      if (fieldCounts[fieldName]) {
        fieldCounts[fieldName]++;
      } else {
        fieldCounts[fieldName] = 1;
      }
    });

    // Convert the stateCounts object into an array of objects
    const result = Object.keys(fieldCounts).map(x => ({
      entity: x,
      count: fieldCounts[x]
    }));

    return result;
  }
};

export const MasterJobCount = ({ data }) => {
  //console.log(data);

  const counts = {};

  data.forEach(job => {

    const { countryname, statename, state, city } = job;

    if (!counts[countryname]) {
      counts[countryname] = { total: 0, states: {} };
    }

    if (!counts[countryname].states[statename]) {
      counts[countryname].states[statename] = { total: 0, cities: {} };
    }

    if (!counts[countryname].states[statename].cities[city]) {
      counts[countryname].states[statename].cities[city] = 0;
    }

    // Increment counts
    counts[countryname].total += 1;
    counts[countryname].states[statename].total += 1;
    counts[countryname].states[statename].cities[city] += 1;

  })

  return counts;
};

export const CountryDropDown = ({ data }) => {
  const countryCounts = data.reduce((acc, item) => {
    acc[item.countryname] = (acc[item.countryname] || { count: 0, countryname: item.countryname });
    acc[item.countryname].count += 1;
    return acc;
  }, {});

  const distinctCountryList = Object.values(countryCounts).map(x => ({
    label: `${x.countryname} (${x.count})`,
    value: x.countryname
  }));

  return distinctCountryList.sort((a, b) => a.label.localeCompare(b.label));
};

export const StateDropDown = ({ countries, data }) => {
  const filteredCountries = countries ? data.filter(x => countries.includes(x.countryname)) : data;

  const stateCounts = filteredCountries.reduce((acc, item) => {
    acc[item.statename] = (acc[item.statename] || { count: 0, state: item.statename, country: item.countryname });
    acc[item.statename].count += 1;
    return acc;

  }, {});

  const distinctStateList = Object.values(stateCounts)
    .filter(x => x.state !== '')
    .map(x => ({
      label: `${x.state} (${x.count})`,
      value: x.state,
      country: x.country
    }));

  return distinctStateList.sort((a, b) => a.label.localeCompare(b.label));
};

export const CityDropDown = ({ states, data }) => {

  const filteredStates = states ? data.filter(x => states.includes(x.statename)) : data;

  const cityCounts = filteredStates.reduce((acc, item) => {
    acc[item.city] = (acc[item.city] || { count: 0, city: item.city, stateshort: item.state });
    acc[item.city].count += 1;
    return acc;
  }, {});

  const distinctCityList = Object.values(cityCounts)
    .filter(x => x.city !== '')
    .map(x => ({
      label: `${x.city}, ${x.stateshort}  (${x.count})`,
      value: x.city
    }));

  //console.log(distinctCityList);

  return distinctCityList.sort((a, b) => a.label.localeCompare(b.label));
};

export const CategoryDropDown = ({ data }) => {
  const categoryCounts = data.reduce((acc, item) => {
    acc[item.category] = (acc[item.category] || { count: 0, category: item.category });
    acc[item.category].count += 1;
    return acc;
  }, {});

  const distinctCategoryList = Object.values(categoryCounts).map(x => ({
    label: `${x.category} (${x.count})`,
    value: x.category
  }));

  return distinctCategoryList.sort((a, b) => a.label.localeCompare(b.label));
}

export const DivisionDropDown = ({ data }) => {
  const divisionCount = data.reduce((acc, item) => {
    acc[item.division] = (acc[item.division] || { count: 0, division: item.division });
    acc[item.division].count += 1;
    return acc;
  }, {});

  const distinctDivisionList = Object.values(divisionCount).map(x => ({
    label: `${x.division} (${x.count})`,
    value: x.division
  }));

  return distinctDivisionList.sort((a, b) => a.label.localeCompare(b.label));
}

export const StatusDropDown = ({ data }) => {
  const fulltime = data.filter(x => x.fulltime == true).length;
  const parttime = data.filter(x => x.fulltime == false).length;
  return [
    { label: "Full Time (" + fulltime + ")", value: true },
    { label: "Part Time (" + parttime + ")", value: false },
  ];
}

export const FilterTypeList = ({ type, data }) => {
  if (data) {
    const filterType = data.filter(x => x.label === type);
    if (filterType) {
      return filterType.map(x => x.value);
    }
  }
}